import OrgBook from './src/main.js'

const components = []
const install = function (Vue, opts = {}) {
  if (install.installed) return
  components.forEach(component => {
    Vue.component(component.name, component)
  })
  Vue.prototype.$QtOrgBook = OrgBook
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default { install }
